import React from "react";
import { useOutletContext, Link } from "react-router-dom";
import { useLanguage } from "../../hooks/useLanguage";

function MyCount(){
  const { t } = useLanguage();
  const { myInfo } = useOutletContext();


  return(
    <div className="my_count_info">
      <ul className='flex-center-12'>
        <Link to="/order/visit">
          <li className='flex-center-4'>{t('shopping_cart')}<span>{myInfo?.cart_count}</span>
          </li>
        </Link>
        <Link to="/myPage/wishList">
          <li className='flex-center-4'>{t('interest_product')}<span>{myInfo?.goods_like_count}</span>
          </li>
        </Link>
        <Link to="/myPage/coupon">
          <li className='flex-center-4'>{t('coupon')}<span>{myInfo?.coupon_count}</span>
          </li>
        </Link>
      </ul>
    </div>
  )
};

export default MyCount;